import React from "react";

import { Route, Routes } from "react-router-dom";

import SignIn from "./features/auth/signin";
import SignUp from "./features/auth/signup";

import VerifiOtp from "./features/auth/verify-otp";

import PrivateRoute from "./routes/private";
import MainRoutes from "./routes";
import LandingPage from "./features/landingPage";
import { Toaster } from "react-hot-toast";
import ForgotPassword from "./features/auth/forgot-password";
import ResetPassword from "./features/auth/password-reset";
import PrivacyPolicy from "./features/landingPage/privacyPolicy";
import Search from "./features/landingPage/guestSearch";

function App() {
  return (
    <>
      <Toaster position="top-right" />

      <Routes>
        <Route
          path="/*"
          element={
            <PrivateRoute>
              <MainRoutes />
            </PrivateRoute>
          }
        />
        <Route path="/" element={<LandingPage />} />

        <Route path="/sign-in" element={<SignIn />} />
        <Route path="/sign-up" element={<SignUp />} />
        <Route path="/verify-otp" element={<VerifiOtp />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/search" element={<Search />} />
      </Routes>
    </>
  );
}

export default App;
